export default function getChainName(chain) {
  switch (chain) {
    case "0x01":
      return "Chain: ETH";
    case "0x38":
      return "Chain: BNB";
    case "0x89":
      return "Chain: MATIC";
    case "0xa86a":
      return "Chain: AVAX";
    case "0xa869":
      return "Chain: AVAX Testnet";
    case "0x61":
      return "Chain: BNB Testnet";
    case "0x05":
      return "Chain: GOERLI";
    default:
      return "";
  }
}

export const getTokenName = (chain) => {
  switch (chain) {
    case "0x01":
      return "ETH";
    case "0x38":
      return "BNB";
    case "0x89":
      return "MATIC";
    case "0xa86a":
      return "AVAX";
    case "0xa869":
      return "AVAX";
    case "0x61":
      return "BNB";
    case "0x05":
      return "ETH";
    default:
      return "";
  }
};

export const getCoinGeckoId = (chain) => {
  switch (chain) {
    case "0x01":
      return "ethereum";
    case "0x38":
      return "binancecoin";
    case "0x61":
      return "binancecoin";
    case "0x05":
      return "ethereum";
    case "0xa86a":
      return "avalanche-2";
    case "0xa869":
      return "avalanche-2";
    case "weth":
      return "ethereum";
    case "wbnb":
      return "binancecoin";
    case "wavax":
      return "avalanche-2";
    default:
      return "";
  }
};

export const getCoinGeckoWrappedTokenId = (chain) => {
  switch (chain) {
    case "0x01":
      return "weth";
    case "0x38":
      return "wbnb";
    case "0xa86a":
      return "wavax";
    case "0xa869":
      return "wavax";
    case "0x61":
      return "wbnb";
    case "0x05":
      return "weth";
    default:
      return "";
  }
};
